import { z } from 'zod';
import { GeoLocation } from './content.js';
import { EngagementCounts } from './engagement.js';
/**
 * Editable fields after creation. Taxonomies and audience are deliberately
 * absent — locked after publication (docs/03 §5.2, pending Q-15): every
 * downstream filter depends on them not shifting under members' feet.
 * `scheduledAt` is editable only while the post is still scheduled
 * (AC-POST-08.2).
 */
export const UpdatePostInput = z
    .object({
    title: z.string().min(1).max(120).optional(),
    body: z.string().max(5_000).optional(),
    hashtags: z.array(z.string()).max(30).optional(),
    commentsEnabled: z.boolean().optional(),
    opvEnabled: z.boolean().optional(),
    location: GeoLocation.nullable().optional(),
    scheduledAt: z.coerce.date().optional(),
})
    .refine((patch) => Object.keys(patch).length > 0, { message: 'Empty patch' });
export const DeleteResult = z.object({
    id: z.string(),
    status: z.literal('deleted'),
});
/** Favourite is a PUBLIC count (docs/03 §24); Saved Post awaits Q-06. */
export const FavouriteState = z.object({
    contentId: z.string(),
    favourited: z.boolean(),
    engagement: EngagementCounts,
});
//# sourceMappingURL=content-mutations.js.map